module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/ea3beb174bfdfd40d4896324288e8f70.png";